<template>
    <section id="tour_booking_submission" class="section_padding">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="clearfix mb20" id="flight-selected">
                        <div class="itinerary-content mb30">
                            <div v-if="this.tripType != 'multi_city'" class="row no-margin align-items-center"
                                id="itinerary-content-outbound-header">
                                <div class="col-md-6 col-6">
                                    <div class="inline-middle">
                                        <h4 class="new-bold-light bold mb0 pb-2">{{ $t('Departure Flight') }}</h4>
                                        <span class="dep-date font-14">
                                            {{ $t(new
                                                Date(this.searchData.date).toLocaleDateString('en-US', {
                                                    month: 'long'
                                                })) }}
                                            {{ new Date(this.searchData.date).toLocaleDateString('en-US',
                                                { day: 'numeric' }) }}
                                            {{ new Date(this.searchData.date).getFullYear() }}
                                        </span>
                                    </div>
                                </div>
                                <div class="col-md-6 col-6">
                                    <router-link
                                        :to="'/flight-policies/departure?from=' + this.searchData.from + '&' + 'to=' + this.searchData.to"
                                        class="btn-view-policies new-light pull-right">
                                        <span class="inline-middle mr5 ml5">{{ $t('View Policies') }}</span>
                                        <i class="fl-30-ico fl-fare-rules-green"></i>
                                    </router-link>
                                </div>
                            </div>
                            <div v-else class="row no-margin align-items-center" id="itinerary-content-outbound-header">
                                <div class="col-md-6 col-6">
                                    <div class="inline-middle">
                                        <h4 class="new-bold-light bold mb0 pb-2">{{ $t('Flight details') }}</h4>
                                    </div>
                                </div>
                                <div class="col-md-6 col-6">
                                    <router-link to="/flight-policies/flight"
                                        class="btn-view-policies new-light pull-right">
                                        <span class="inline-middle mr5 ml5">{{ $t('View Policies') }}</span>
                                        <i class="fl-30-ico fl-fare-rules-green"></i>
                                    </router-link>
                                </div>
                            </div>
                            <div class="row  align-items-center mb-3">
                                <div class="col-md-5">
                                    <div class="p10 bg-white" id="itinerary-content-outbound-map">
                                        <div id="outbound-map" class="flight-map">
                                            <img :src="this.getOutboundImg">
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-7">
                                    <div class="departure-itinerary">
                                        <div class="itinerary">
                                        </div>
                                        <div class="clearfix summary"> </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="this.tripType != 'multi_city' && this.tripType != 'oneway'" class="col-md-12">
                    <div class="clearfix mb20" id="flight-selected">
                        <div class="itinerary-content ib-con mb20">
                            <div class="row no-margin align-items-center">
                                <div class="col-md-6 col-6">
                                    <div class="inline-middle">
                                        <h4 class="new-bold-light bold  mb0 pb-2">{{ $t('Return Flight') }}</h4>
                                        <span class="arr-date font-14">
                                            {{ $t(new
                                                Date(this.searchData.ret_date).toLocaleDateString('en-US', {
                                                    month: 'long'
                                                })) }}
                                            {{ new Date(this.searchData.ret_date).toLocaleDateString('en-US',
                                                { day: 'numeric' }) }}
                                            {{ new Date(this.searchData.ret_date).getFullYear() }}
                                        </span>
                                    </div>
                                </div>
                                <div class="col-md-6 col-6">
                                    <router-link
                                        :to="'/flight-policies/arrival?from=' + this.searchData.to + '&' + 'to=' + this.searchData.from"
                                        class="btn-view-policies new-light pull-right">
                                        <span class="inline-middle mr5 ml5">{{ $t('View Policies') }}</span>
                                        <i class="fl-30-ico fl-fare-rules-green"></i>
                                    </router-link>
                                </div>
                            </div>
                            <div class="row align-items-center mb-3">
                                <div class="col-md-5">
                                    <div class="p10 bg-white">
                                        <div id="inbound-map" class="map">
                                            <img :src="this.getInboundImg">
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-7">
                                    <div class="arrival-itinerary ib-con">
                                        <div class="itinerary">
                                        </div>
                                        <div class="clearfix summary"> </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="this.allowed_to_request_hotel_reservation == 1 && this.essential_guest == 1 && this.is_self_paying == 0"
                    class="col-md-12">
                    <div class="clearfix mb20">
                        <div class="itinerary-content ib-con mb20">
                            <div class="row no-margin align-items-center">
                                <div class="col-md-6 col-6">
                                    <div class="inline-middle">
                                        <h4 class="new-bold-light bold  mb0 pb-2">{{ $t('Hotels') }}</h4>
                                    </div>
                                </div>
                            </div>
                            <div class="row p10 pt-0 pb-0 mt-2">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label>
                                            {{
                                                $t('Do you need to book a hotel?')
                                            }}*
                                        </label>
                                        <select class="form-control" v-model="is_need_booking">
                                            <option value="">{{ $t('select2') }}</option>
                                            <option value="1">{{ $t('I need a booking') }}</option>
                                            <option value="0">{{ $t('I dont need a booking') }}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div v-if="is_need_booking == '0'" class="row p10 pt-0 pb-0 mt-2">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label>
                                            {{
                                                $t('Will you stay with a friend from the Saudi Cup?')
                                            }}*
                                        </label>
                                        <select class="form-control" v-model="stay_with_friend">
                                            <option value="">{{ $t('select2') }}</option>
                                            <option value="1">{{ $t('yes') }}</option>
                                            <option value="0">{{ $t('no') }}</option>
                                        </select>
                                    </div>
                                </div>
                                <div v-if="stay_with_friend == '1'" class="col-md-12">
                                    <div class="form-group">
                                        <label>
                                            {{
                                                $t('Registration number')
                                            }}*
                                        </label>
                                        <input type="text" class="form-control" :placeholder="$t('Registration number')"
                                            v-model="registration_number">
                                    </div>
                                </div>
                                <div v-else-if="stay_with_friend == '0'" class="col-md-12">
                                    <div class="form-group">
                                        <label>
                                            {{
                                                $t('Where will you stay?')
                                            }}*
                                        </label>
                                        <select class="form-control" v-model="stay_type">
                                            <option value="">{{ $t('select2') }}</option>
                                            <option value="1">{{ $t('Hotel') }}</option>
                                            <option value="0">{{ $t('External accommodation') }}</option>
                                        </select>
                                    </div>
                                </div>
                                <div v-if="stay_type == '1'" class="col-md-12">
                                    <div class="form-group">
                                        <label>
                                            {{
                                                $t('Hotel name')
                                            }}*
                                        </label>
                                        <input type="text" class="form-control" :placeholder="$t('Hotel name')"
                                            v-model="hotel_reference">
                                    </div>
                                </div>
                                <div v-if="stay_with_friend == '0' && stay_type != ''" class="col-md-12">
                                    <div class="form-group">
                                        <label>
                                            {{
                                                $t('Location')
                                            }}*
                                        </label>
                                        <input type="text" class="form-control" :placeholder="$t('Location')"
                                            v-model="site_url">
                                    </div>
                                </div>
                            </div>
                            <div v-else-if="is_need_booking == '1'">
                                <div class="row align-items-center mb-3">
                                    <div class="col-md-5">
                                        <div class="p10 bg-white">
                                            <div id="inbound-map" class="map">
                                                <img :src="this.hotel_img">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-7">
                                        <div class="row p10 pt-0 pb-0">
                                            <div class="col-md-12">
                                                <div class="form-group">
                                                    <label>{{ $t('Hotel name') }}</label>
                                                    <select v-model="hotel_id" @change="changeHotel"
                                                        class="form-control">
                                                        <option v-for="hotel in hotels" :value="hotel.id">{{
                                                            hotel[this.$i18n.locale + '_name'] }}
                                                        </option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="col-md-12">
                                                <div class="mb-3">
                                                    <h4 class="font-size-18 mb-3 color-label">
                                                        <span class="note">{{ $t('Note') }} :
                                                        </span>
                                                        {{ $t('You are eligible for') }}
                                                        {{ hotel_conditions.free_duration }} x
                                                        {{ $t('free nights between') }}
                                                        {{
                                                            formattedDateRange(hotel_conditions.free_reservation_start_date,
                                                                hotel_conditions.free_reservation_end_date) }}
                                                    </h4>
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label>{{ $t('Free reservation start date') }}</label>
                                                    <input v-if="this.tripType != 'oneway'" type="text"
                                                        class="form-control" :value="entry_hotel_date" disabled>
                                                    <VueDatePicker v-else v-model="entry_date"
                                                        :enable-time-picker="false"
                                                        :min-date="formattedDate(this.hotel_conditions.reservation_start_date)"
                                                        :max-date="this.departure_time_for_riyadh"
                                                        :start-date="formattedDate(this.hotel_conditions.reservation_start_date)"
                                                        prevent-min-max-navigation @internal-model-change="changeEntry"
                                                        :placeholder="$t('select2')" />
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label>{{ $t('Free reservation end date') }}</label>
                                                    <input type="text" class="form-control" :value="exit_hotel_date"
                                                        disabled>
                                                </div>
                                            </div>
                                            <div class="col-md-12">
                                                <div class="form-group">
                                                    <label>
                                                        {{
                                                            $t('Room type')
                                                        }}
                                                    </label>
                                                    <select class="form-control" v-model="room_type">
                                                        <option value="">{{ $t('select2') }}</option>
                                                        <option value="King Bed">{{ $t('King bed') }}</option>
                                                        <option value="Double Bed">{{ $t('Twin beds') }}</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="need_extra_end" class="row p10 pt-0 pb-0">
                                    <div class="col-md-12 pl-5 pr-5">
                                        <hr>
                                    </div>
                                    <div class="col-md-12 text-center mt-3 mb-3">
                                        <div class="mb-3">
                                            <h4 class="font-size-18 mb-3 text-danger">
                                                <span class="note">{{ $t('Note') }} :
                                                </span>
                                                {{ $t('Saudi Cup will not cover extra nights') }}
                                            </h4>
                                        </div>
                                        <a v-if="confirm == 1" href="javascript:void(0);" @click="this.confirm = 0"
                                            class="bold mb-1">
                                            {{ $t('back') }}
                                            <i class="fl-30-ico fl-fare-rules-green"></i>
                                        </a>
                                    </div>
                                    <div v-if="confirm == 1" class="col-md-12 mb-3">
                                        <div class="form-group">
                                            <label>
                                                {{
                                                    $t('do you want to book by yourself or need assistance')
                                                }}
                                            </label>
                                            <a href="javascript:void(0);" @click="this.confirm = 0"
                                                class="pull-right bold mb-1">
                                                {{ $t('back') }}
                                                <i class="fl-30-ico fl-fare-rules-green"></i>
                                            </a>
                                            <select class="form-control" v-model="need_assistance">
                                                <option value="">{{ $t('select2') }}</option>
                                                <option value="0">{{ $t('I want book by myself') }}</option>
                                                <option value="1">
                                                    {{
                                                        $t('I need assistance') }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="need_assistance == 1 && confirm == 1" class="row p10 pt-0 pb-0">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label>{{ $t('Number of nights') }}</label>
                                            <input type="text" class="form-control" :value="count_extra_end" disabled>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label>{{ $t('Check-in date') }}</label>
                                            <input type="text" class="form-control" :value="exit_hotel_date" disabled>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label>{{ $t('Check-out date') }}</label>
                                            <input type="text" class="form-control" :value="end_extra_date" disabled>
                                        </div>
                                    </div>
                                    <div class="col-md-12 mb-3">
                                        <div class="form-group">
                                            <label>
                                                {{
                                                    $t('Room type')
                                                }}
                                            </label>
                                            <select class="form-control" v-model="extra_room_type">
                                                <option value="">{{ $t('select2') }}</option>
                                                <option value="King Bed">{{ $t('King bed') }}</option>
                                                <option value="Double Bed">{{ $t('Twin beds') }}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="confirm == 0 && need_extra_end" class="col-md-12 text-center mb-4">
                                    <button type="button" class="btn btn_theme_two pl-0 pr-0 btn_md w-15 mr-5 ml-5"
                                        onclick="window.location = '/flight-search-result';">
                                        <h5 class="inline-middle bold mr5 ml5">{{ $t('select different flight') }}</h5>
                                    </button>
                                    <button type="button" class="btn btn_theme btn_md w-15 pl-0 pr-0  mr-5 ml-5"
                                        @click="this.confirm = 1;">
                                        <h5 class="inline-middle bold mr5 ml5">{{ $t('confirm my choice') }}</h5>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="need_payment == 1" class="col-lg-12 mt-4">
                    <div class="tour_details_right_sidebar_wrapper">
                        <div class="tour_detail_right_sidebar">
                            <div class="tour_details_right_boxed">
                                <div class="row no-margin align-items-center">
                                    <div class="col-md-6 col-6">
                                        <div class="inline-middle">
                                            <h4 class="new-bold-light bold  mb0 pb-2">{{ $t('payment information') }}
                                            </h4>
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="tour_booking_amount_area">
                                            <ul>
                                                <li>{{ $t('Total') }}<span>{{ total.toLocaleString(undefined, {
                                                    minimumFractionDigits: 2
                                                }) }} {{ $t('SAR') }}</span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div v-if="payment_method == ''" class="col-md-12 mt-4">
                                        <div class="form-group">
                                            <label>
                                                {{ $t('payment method') }}
                                            </label>
                                            <select class="form-control" v-model="payment_method"
                                                @change="payment_method_change">
                                                <option value="">{{ $t('select2') }}</option>
                                                <option value="MADA">MADA</option>
                                                <option value="VISA MASTER">VISA MASTER</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="mt-3">
                                            <form id="payment_form"
                                                :action="this.$saudicupAppUrl + '/api/result/' + checkoutId + '?redirect_url=' + payment_redirect_url"
                                                class="paymentWidgets" :data-brands="payment_method"></form>
                                        </div>
                                    </div>
                                    <div v-if="is_payment_loading == 1"
                                        class="col-md-12 text-center mt-5 mb-5 pt-5 pb-5">
                                        <lv-loader type="ball-pulse" :scale="1.3" :color="'#8154a1'" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="need_payment == 0" class="col-lg-12 mt-4">
                    <div class="tour_details_right_sidebar_wrapper sticky-parent">
                        <div class="tour_detail_right_sidebar">
                            <div class="tour_details_right_boxed">
                                <div class="row text-center">
                                    <div class="col-md-12">
                                        <button type="button" class="btn btn_theme btn_md w-35  mt-4" @click="send">{{
                                            $t('Confirm the reservation and issue the ticket') }}</button>
                                        <div class="form-group mt-4">
                                            <input type="checkbox" id="confirm"
                                                class="form-check-input confirm-issue mt-0" v-model="confirm_issue">
                                            <label for="confirm" class="text-danger pl-2 pr-2 mb-0">
                                                {{ $t("confirm note") }}
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
var that;
import $ from 'jquery';
import jsonDataAr from '@/assets/file/ar-airports.json';
import jsonDataEn from '@/assets/file/en-airports.json';
import airlinesData from '@/assets/file/airlines.json';
import { toast } from 'vue3-toastify';
import LvLoader from 'lightvue/loaders';
export default {
    name: 'FlightDetailsArea',
    data: () => ({
        site_url: '',
        hotel_reference: '',
        stay_type: '',
        registration_number: '',
        stay_with_friend: '',
        is_need_booking: '',
        date: '',
        ret_date: '',
        departure: null,
        arrival: null,
        departure_flight: null,
        arrival_flight: null,
        airlines: [],
        passengers: [],
        flightOffers: [],
        agree: true,
        booking_id: '',
        searchData: [],
        getOutboundImg: '',
        getInboundImg: '',
        tripType: '',
        from: [],
        to: [],
        allowed_to_request_hotel_reservation: 0,
        hotels: [],
        hotel_img: '',
        hotel_conditions: [],
        hotel_id: '',
        current_hotel: [],
        room_type: '',
        extra_room_type: '',
        arrival_time_to_riyadh: '',
        departure_time_for_riyadh: '',
        entry_hotel_date: '',
        exit_hotel_date: '',
        need_extra_end: false,
        need_assistance: '',
        count_extra_end: false,
        end_extra_date: '',
        essential_guest: 0,
        confirm: 0,
        confirm_issue: false,
        entry_date: null,
        total: 0,
        need_payment: 1,
        is_self_paying: 1,
        is_payment_loading: 0,
        payment_method: '',
        checkoutId: '',
        payment_redirect_url: '',
        markup: 0,
        payment_status: 0
    }),
    components: {
        LvLoader
    },
    methods: {
        get_price_with_markup(price) {
            price = parseFloat(price);
            var markup_percent = 0.1;
            this.markup = this.is_self_paying == 1 ? price * markup_percent : 0;
            var total = price + this.markup;
            return total;
        },
        payment_method_change() {
            this.is_payment_loading = 1;
            $('html, body').animate({ scrollTop: $(document).height() }, 'slow');
            var guest_data = JSON.parse(localStorage.getItem("guest_data"));
            var body = {
                guest_id: guest_data.guest.id,
                payment_method: this.payment_method,
                amount: parseFloat(this.total).toFixed(2),
                subject: 'flight',
            };
            var url = `${this.$saudicupAppUrl}/api/prepare-the-checkout`;
            this.axios.post(url, body).then((response) => {
                this.checkoutId = response.data.checkoutId;
                this.payment_redirect_url = window.location.origin + '/booking-confirmation/';
                let recaptchaScript = document.createElement('script');
                recaptchaScript.setAttribute('src', 'https://eu-prod.oppwa.com/v1/paymentWidgets.js?checkoutId=' + this.checkoutId);
                recaptchaScript.setAttribute('strategy', 'afterInteractive');
                document.head.appendChild(recaptchaScript);
                recaptchaScript.onload = () => {
                    setTimeout(() => {
                        $('.wpwl-control-brand').children('option').each(function () {
                            $(this).html(that.$t($(this).text()));
                        });

                        $(document).find('.wpwl-label-cardNumber').html(this.$t('Card Number'));
                        $(document).find('[name="card.number"]').attr('placeholder', this.$t('Card Number'));

                        if (that.$i18n.locale === 'ar') {
                            $(document).find('[name="card.number"]').css('direction', 'ltr');
                            $(document).find('[name="card.number"]').css('text-align', 'right');
                        }

                        $(document).find('.wpwl-label-expiry').html(this.$t('Expiry Date'));
                        $(document).find('.wpwl-control-expiry').attr('placeholder', this.$t('MM / YY'));

                        $(document).find('.wpwl-label-cvv').html(this.$t('CVV'));
                        $(document).find('[name="card.cvv"]').attr('placeholder', this.$t('CVV'));

                        $(document).find('.wpwl-label-cardHolder').html(this.$t('Card holder'));
                        $(document).find('.wpwl-control-cardHolder').attr('placeholder', this.$t('Card holder'));

                        $(document).find('.wpwl-button-pay').html(this.$t('Pay now'));
                        that.is_payment_loading = 0;
                        $('html, body').animate({ scrollTop: $(document).height() }, 'slow');
                    }, 100);
                }
            });
        },
        formattedDate(date) {
            const parts = date.split('/');
            return new Date(`${parts[2]}-${parts[1]}-${parts[0]}`);
        },
        formattedDateRange(startDate, endDate) {
            const startParts = startDate.split('/');
            const endParts = endDate.split('/');
            const start = new Date(`${startParts[2]}-${startParts[1]}-${startParts[0]}`);
            const end = new Date(`${endParts[2]}-${endParts[1]}-${endParts[0]}`);
            return `${start.toLocaleDateString(undefined, { day: 'numeric' })} - ${end.toLocaleDateString('en-US', { day: 'numeric' })} ${this.$t(end.toLocaleDateString('en-US', { month: 'long' }))} ${end.toLocaleDateString('en-US', { year: 'numeric' })}`;
        },
        date_format(date) {
            var dateObject = new Date(date);
            const formattedDate = dateObject.toLocaleDateString('fr-CA', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
            });
            return formattedDate;
        },
        add_days_to_date(date, days) {
            var dateObject = new Date(date);
            dateObject.setDate(dateObject.getDate() + parseInt(days));
            const formattedDate = dateObject.toLocaleDateString('fr-CA', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
            });
            return formattedDate;
        },
        decrease_day_from_date(date) {
            const dateObject = new Date(date);
            dateObject.setDate(dateObject.getDate() - 1);
            const formattedDate = dateObject.toLocaleDateString('fr-CA', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
            });
            return formattedDate;
        },
        need_an_extra_day_at_beginning(date, time, time_allowed_entry_before_booking) {
            var date1 = date.toLocaleDateString('en-US', {
                year: 'numeric'
            }) + '-' + date.toLocaleDateString('en-US', {
                month: '2-digit'
            }) + '-' + date.toLocaleDateString('en-US', {
                day: '2-digit'
            });
            const startTime = new Date(date);
            startTime.setHours(startTime.getHours() + time_allowed_entry_before_booking);
            const endTime = new Date(`${date1}T${time}`);
            const timeDifference = endTime - startTime;
            const hoursDifference = timeDifference / (1000 * 60 * 60);
            return hoursDifference > 0 ? true : false;
        },
        need_an_extra_day_at_end(date1, date2) {
            var date1 = new Date(date1), date2 = new Date(date2);
            const utcDate1 = Date.UTC(date1.getFullYear(), date1.getMonth(), date1.getDate());
            const utcDate2 = Date.UTC(date2.getFullYear(), date2.getMonth(), date2.getDate());
            const timeDiff = utcDate2 - utcDate1;
            const daysDiff = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
            return daysDiff > 0 ? true : false;
        },
        count_extra_day_at_end(date1, date2) {
            var date1 = new Date(date1), date2 = new Date(date2);
            const utcDate1 = Date.UTC(date1.getFullYear(), date1.getMonth(), date1.getDate());
            const utcDate2 = Date.UTC(date2.getFullYear(), date2.getMonth(), date2.getDate());
            const timeDiff = utcDate2 - utcDate1;
            const daysDiff = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
            return daysDiff;
        },
        get_time_formated(date) {
            var dateObject = new Date(date);
            var hours = dateObject.getHours();
            var minutes = dateObject.getMinutes();
            const formattedTime = `${hours.toLocaleString('en-US', { minimumIntegerDigits: 2 })}:${minutes.toLocaleString('en-US', { minimumIntegerDigits: 2 })}`;
            return formattedTime;
        },
        changeEntry(date) {
            const dateStr1 = date;
            const dateStr2 = this.entry_date;
            const date1 = new Date(dateStr1);
            const date2 = new Date(dateStr2);
            if (date1 < date2 || date1 > date2) {
                setTimeout(() => {
                    $(document).find('.dp__action_select').click();
                }, 50);
            }
            if (this.entry_date) {
                this.arrival_time_to_riyadh = this.entry_date;
                this.entry_hotel_date = this.date_format(this.arrival_time_to_riyadh);
                this.exit_hotel_date = this.add_days_to_date(this.entry_hotel_date, this.hotel_conditions.free_duration);
                if (this.exit_hotel_date > this.departure_time_for_riyadh) {
                    this.exit_hotel_date = new Date(this.departure_time_for_riyadh).toLocaleDateString('fr-CA', {
                        year: 'numeric',
                        month: '2-digit',
                        day: '2-digit',
                    });
                }
                this.need_extra_end = this.need_an_extra_day_at_end(this.exit_hotel_date, this.departure_time_for_riyadh);
                if (this.need_extra_end) {
                    this.count_extra_end = this.count_extra_day_at_end(this.exit_hotel_date, this.departure_time_for_riyadh);
                    this.end_extra_date = this.add_days_to_date(this.exit_hotel_date, this.count_extra_end);
                }
            }
        },
        changeHotel() {
            this.need_assistance = 0;
            this.confirm = 0;
            this.current_hotel = this.hotels.filter(item => {
                return item.id == this.hotel_id;
            })[0];
            this.hotel_img = `${this.$saudicupAppUrl}/storage` + this.current_hotel.images[0].image;
            var time_allowed_entry_before_booking = this.current_hotel.time_allowed_entry_before_booking;
            var need_extra = this.need_an_extra_day_at_beginning(new Date(this.arrival_time_to_riyadh), this.get_time_formated(this.current_hotel.entry_time), time_allowed_entry_before_booking);
            var free_duration = this.hotel_conditions.free_duration;
            if (need_extra) {
                this.entry_hotel_date = this.decrease_day_from_date(this.arrival_time_to_riyadh);
                free_duration = parseInt(free_duration) + 1;
            } else {
                this.entry_hotel_date = this.date_format(this.arrival_time_to_riyadh);
            }
            this.exit_hotel_date = this.add_days_to_date(this.entry_hotel_date, free_duration);
            if (this.exit_hotel_date > this.departure_time_for_riyadh) {
                this.exit_hotel_date = new Date(this.departure_time_for_riyadh).toLocaleDateString('fr-CA', {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                });
            }
            this.need_extra_end = this.need_an_extra_day_at_end(this.exit_hotel_date, this.departure_time_for_riyadh);
            if (this.tripType == 'oneway') {
                this.exit_hotel_date = null;
                this.entry_hotel_date = null;
                this.need_extra_end = false;
                this.entry_date = null;
            }
            if (this.need_extra_end) {
                this.count_extra_end = this.count_extra_day_at_end(this.exit_hotel_date, this.departure_time_for_riyadh);
                this.end_extra_date = this.add_days_to_date(this.exit_hotel_date, this.count_extra_end);
            }
        },
        convertDuration(duration) {
            const regex = /PT(\d+)H(\d+)M/;
            const regex2 = /PT(\d+)H/;
            const match = regex.exec(duration);
            const match2 = regex2.exec(duration);
            if (match) {
                const hours = match[1].padStart(2, '0');
                const minutes = match[2].padStart(2, '0');
                if (that.$i18n.locale === 'en') {
                    return hours + 'h ' + minutes + 'm';
                }
                return hours + 'س ' + minutes + 'د';
            } else if (match2) {
                const hours = match2[1].padStart(2, '0');
                const minutes = '00';
                if (that.$i18n.locale === 'en') {
                    return hours + 'h ' + minutes + 'm';
                }
                return hours + 'س ' + minutes + 'د';
            }
            return '';
        },
        getLocationByCode(code) {
            var jsonData = jsonDataAr;
            if (that.$i18n.locale === 'en') {
                jsonData = jsonDataEn;
            }
            var info = jsonData.filter(item => {
                return item.code.includes(code);
            });
            return info[0];
        },
        send_payment_invoice(total, base, markup) {
            var guest_data = JSON.parse(localStorage.getItem("guest_data"));
            var body = {
                guest_id: guest_data.guest.id,
                total: total,
                base: base,
                markup: parseFloat(markup).toFixed(2),
            };
            var url = `${this.$appUrl}/api/flights/saudicup/send_payment_invoice`;
            this.axios.post(url, body, { headers: { Authorization: `Bearer ${localStorage.getItem('user_token')}` } }).then((response) => {
                // toast.success(this.$t('An email has been sent with payment information'), {
                //     autoClose: 5000,
                //     position: toast.POSITION.TOP_CENTER,
                //     closeButton: false
                // });
            });
        },
        send() {
            if (!this.is_need_booking) {
                toast.error(this.$t('All fields are required'), {
                    autoClose: 3500,
                    position: toast.POSITION.TOP_CENTER,
                    closeButton: false
                });
                return;
            }
            if (this.is_need_booking == '0') {
                if (!this.stay_with_friend) {
                    toast.error(this.$t('All fields are required'), {
                        autoClose: 3500,
                        position: toast.POSITION.TOP_CENTER,
                        closeButton: false
                    });
                    return;
                }
            }
            if (this.is_need_booking == '1' && this.allowed_to_request_hotel_reservation == 1 && this.essential_guest == 1 && this.is_self_paying == 0) {
                if (this.tripType == 'oneway' && this.entry_date == null) {
                    toast.error(this.$t('Hotel check-in date is required'), {
                        autoClose: 3500,
                        position: toast.POSITION.TOP_CENTER,
                        closeButton: false
                    });
                    return;
                }
                if (this.room_type == '') {
                    toast.error(this.$t('Room type required'), {
                        autoClose: 3500,
                        position: toast.POSITION.TOP_CENTER,
                        closeButton: false
                    });
                    return;
                }
                if (this.need_extra_end) {
                    if (this.confirm == 0) {
                        toast.error(this.$t('Please confirm your choice'), {
                            autoClose: 3500,
                            position: toast.POSITION.TOP_CENTER,
                            closeButton: false
                        });
                        return;
                    }
                    if (this.need_assistance == '') {
                        toast.error(this.$t('All fields are required'), {
                            autoClose: 3500,
                            position: toast.POSITION.TOP_CENTER,
                            closeButton: false
                        });
                        return;
                    }
                    if (this.need_assistance == 1) {
                        if (this.extra_room_type == '') {
                            toast.error(this.$t('Room type required'), {
                                autoClose: 3500,
                                position: toast.POSITION.TOP_CENTER,
                                closeButton: false
                            });
                            return;
                        }
                    }
                }
            }
            if (!this.confirm_issue) {
                toast.error(this.$t('Please agree to the terms'), {
                    autoClose: 3500,
                    position: toast.POSITION.TOP_CENTER,
                    closeButton: false
                });
                return;
            }
            $('.pre-loader').show();
            var guest_data = JSON.parse(localStorage.getItem("guest_data")),
                guest_id = localStorage.getItem("guest_id"),
                redirect_url = localStorage.getItem("redirect_url"),
                user_token = localStorage.getItem("user_token"),
                trip_type = localStorage.getItem("tripType"),
                sector = '',
                from = [],
                to = [],
                date = [];
            if (trip_type == 'multi_city') {
                const params = new URLSearchParams(this.searchData.info);
                from = params.getAll('from[]');
                to = params.getAll('to[]');
                date = params.getAll('date[]');
                sector = from[0] + '/' + to[0] + '/' + from[1] + '/' + to[1];
            } else if (trip_type == 'oneway') {
                sector = this.searchData.from + '/' + this.searchData.to;
            } else {
                sector = this.searchData.from + '/' + this.searchData.to + '/' + this.searchData.from;
            }
            var hotel_body = {
                is_need_booking: 1,
                hotel_id: this.hotel_id,
                guest_id: guest_data.guest.id,
                on_his_expense: 0,
                start_date: this.entry_hotel_date,
                end_date: this.exit_hotel_date,
                type: guest_data.policy.room_type,
                bed_type: this.room_type,
                extra_nights: this.need_assistance == 1 ? {
                    description: "i want " + this.count_extra_end + " extra nights from " + this.exit_hotel_date + " to " + this.end_extra_date + " and room type is (" + this.extra_room_type + ")",
                    user_id_type: guest_id ? "Guest" : "Group Coordinator"
                } : {}
            };
            if (this.is_need_booking == '0') {
                hotel_body = {
                    is_need_booking: 0,
                    guest_id: guest_data.guest.id,
                    on_his_expense: 0,
                    registration_number: this.registration_number,
                    hotel_reference: this.hotel_reference,
                    site_url: this.site_url,
                    extra_nights: {}
                };
            }
            var flight_order =
            {
                data: {
                    type: "flight-order",
                    flightOffers: this.flightOffers,
                    travelers: [],
                    remarks: {
                        general: [
                            {
                                subType: "GENERAL_MISCELLANEOUS",
                                text: "ONLINE BOOKING FROM INCREIBLE VIAJES"
                            }
                        ]
                    },
                    ticketingAgreement: {
                        option: "DELAY_TO_CANCEL",
                        delay: "6D"
                    },
                    contacts: []
                }
            };
            var body = {
                flightOffers: this.flightOffers,
                flight_order: flight_order,
                adult: this.searchData.adults,
                children: this.searchData.children,
                infant: this.searchData.infants,
                cabin: this.searchData.cabin,
                from: trip_type != 'multi_city' ? this.searchData.from : from[0],
                to: trip_type != 'multi_city' ? this.searchData.to : to[0],
                departure_date: trip_type != 'multi_city' ? this.searchData.date : date[0],
                return_date: trip_type != 'multi_city' ? this.searchData.ret_date : date[1],
                trip_type: trip_type,
                passengers: JSON.parse(localStorage.getItem("passengers")),
                passengers_details: JSON.parse(localStorage.getItem("passengersDetails")),
                guest_data: guest_data,
                guest_id: guest_id,
                user_token: user_token,
                hotel_body: this.is_self_paying == 0 ? hotel_body : null,
                sector: sector,
                is_self_paying: this.is_self_paying,
                markup: parseFloat(this.markup).toFixed(2)
            };
            var url = `${this.$appUrl}/api/saudicup/order`;
            this.axios.post(url, body).then((response) => {
                var res = response.data.data;
                if (response.data.status == 0) {
                    $('.pre-loader').hide();
                    $('.tour_details_right_sidebar_wrapper').remove();
                    if (this.is_self_paying == 0) {
                        toast.error(this.$t('An error occurred on the service provider during the reservation process'), {
                            autoClose: 3500,
                            position: toast.POSITION.TOP_CENTER,
                            closeButton: false
                        });
                    } else {
                        // var passengers_id = [];
                        // var passengers = JSON.parse(localStorage.getItem("passengersDetails"));
                        // passengers.forEach(element => {
                        //     passengers_id.push(element.id);
                        // });
                        // var body_request = {
                        //     "passengers": JSON.stringify(passengers_id),
                        //     "type_of_flight": trip_type,
                        //     "amount": parseFloat(this.total_airline).toFixed(2),
                        //     "guest_id": guest_data.guest.id,
                        //     "departure_from_airport": trip_type != 'multi_city' ? this.searchData.from : from[0],
                        //     "departure_to_airport": trip_type != 'multi_city' ? this.searchData.to : to[0],
                        //     "departure_date": trip_type != 'multi_city' ? this.searchData.date : date[0],
                        //     "departure_time": new Date(this.flightOffers[0].itineraries[0].segments[0].departure.at).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' }),
                        //     "departure_arrival_time": new Date(this.flightOffers[0].itineraries[0].segments[this.flightOffers[0].itineraries[0].segments.length - 1].arrival.at).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' }),
                        //     "booking_degree": this.searchData.cabin,
                        //     "return_from_airport": trip_type != 'multi_city' ? this.searchData.to : to[0],
                        //     "return_to_airport": trip_type != 'multi_city' ? this.searchData.from : from[0],
                        //     "return_date": trip_type != 'multi_city' ? this.searchData.ret_date : date[1],
                        //     "return_time": trip_type != '#oneway' ? new Date(this.flightOffers[0].itineraries[1].segments[0].departure.at).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' }) : null,
                        //     "return_arrival_time": trip_type != '#oneway' ? new Date(this.flightOffers[0].itineraries[1].segments[this.flightOffers[0].itineraries[1].segments.length - 1].arrival.at).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' }) : null,
                        //     "flight_company_name": this.flightOffers[0].validatingAirlineCodes[0],
                        // };
                        // var url = `${this.$saudicupAppUrl}/api/admin/store-self-paying-airline`;
                        // this.axios.post(url, body_request, { headers: { Authorization: `Bearer ${localStorage.getItem('user_token')}` } }).then((response) => {
                        //     $('.pre-loader').hide();
                        //     $('.tour_details_right_sidebar_wrapper').remove();
                        //     toast.success(this.$t('Your reservation request has been sent successfully'), {
                        //         autoClose: 3500,
                        //         position: toast.POSITION.TOP_CENTER,
                        //         closeButton: false
                        //     });
                        //     setTimeout(() => {
                        //         localStorage.clear();
                        //         window.location = redirect_url;
                        //     }, 2000);
                        // });
                    }
                } else {
                    $('.pre-loader').hide();
                    $('.tour_details_right_sidebar_wrapper').remove();
                    toast.success(this.$t('Your reservation was completed successfully'), {
                        autoClose: 3500,
                        position: toast.POSITION.TOP_CENTER,
                        closeButton: false
                    });
                    setTimeout(() => {
                        localStorage.clear();
                        window.location = redirect_url;
                    }, 2000);
                }
            }).catch(error => {
                if (this.is_self_paying == 0) {
                    $('.pre-loader').hide();
                    $('.tour_details_right_sidebar_wrapper').remove();
                    toast.error(this.$t('An error occurred during the booking process'), {
                        autoClose: 3500,
                        position: toast.POSITION.TOP_CENTER,
                        closeButton: false
                    });
                } else {
                    // var passengers_id = [];
                    // var passengers = JSON.parse(localStorage.getItem("passengersDetails"));
                    // passengers.forEach(element => {
                    //     passengers_id.push(element.id);
                    // });
                    // var body_request = {
                    //     "passengers": JSON.stringify(passengers_id),
                    //     "type_of_flight": trip_type,
                    //     "amount": parseFloat(this.total).toFixed(2),
                    //     "guest_id": guest_data.guest.id,
                    //     "departure_from_airport": trip_type != 'multi_city' ? this.searchData.from : from[0],
                    //     "departure_to_airport": trip_type != 'multi_city' ? this.searchData.to : to[0],
                    //     "departure_date": trip_type != 'multi_city' ? this.searchData.date : date[0],
                    //     "departure_time": new Date(this.flightOffers[0].itineraries[0].segments[0].departure.at).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' }),
                    //     "departure_arrival_time": new Date(this.flightOffers[0].itineraries[0].segments[this.flightOffers[0].itineraries[0].segments.length - 1].arrival.at).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' }),
                    //     "booking_degree": this.searchData.cabin,
                    //     "return_from_airport": trip_type != 'multi_city' ? this.searchData.to : to[0],
                    //     "return_to_airport": trip_type != 'multi_city' ? this.searchData.from : from[0],
                    //     "return_date": trip_type != 'multi_city' ? this.searchData.ret_date : date[1],
                    //     "return_time": trip_type != '#oneway' ? new Date(this.flightOffers[0].itineraries[1].segments[0].departure.at).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' }) : null,
                    //     "return_arrival_time": trip_type != '#oneway' ? new Date(this.flightOffers[0].itineraries[1].segments[this.flightOffers[0].itineraries[1].segments.length - 1].arrival.at).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' }) : null,
                    //     "flight_company_name": this.flightOffers[0].validatingAirlineCodes[0],
                    // };
                    // var url = `${this.$saudicupAppUrl}/api/admin/store-self-paying-airline`;
                    // this.axios.post(url, body_request, { headers: { Authorization: `Bearer ${localStorage.getItem('user_token')}` } }).then((response) => {
                    //     $('.pre-loader').hide();
                    //     $('.tour_details_right_sidebar_wrapper').remove();
                    //     toast.success(this.$t('Your reservation request has been sent successfully'), {
                    //         autoClose: 3500,
                    //         position: toast.POSITION.TOP_CENTER,
                    //         closeButton: false
                    //     });
                    //     setTimeout(() => {
                    //         localStorage.clear();
                    //         window.location = redirect_url;
                    //     }, 2000);
                    // });
                }
            });
        }
    },
    mounted() {
        this.is_self_paying = localStorage.getItem("is_self_paying");
        this.need_payment = localStorage.getItem("is_self_paying");
        var is_invoice_send = localStorage.getItem("is_invoice_send") ?? 0;
        if (this.need_payment == 1) {
            var checkoutId = this.$route.params.checkoutId;
            if (checkoutId) {
                url = `${this.$saudicupAppUrl}/api/result/${checkoutId}/1`;
                this.axios.get(url).then((response) => {
                    if (response.data.status == "Transaction succeeded") {
                        this.need_payment = 0;
                        this.payment_status = 1;
                        if (is_invoice_send == 0) {
                            toast.success(this.$t('The payment was completed successfully'), {
                                autoClose: 5000,
                                position: toast.POSITION.TOP_CENTER,
                                closeButton: false
                            });
                        }
                        $('html, body').animate({ scrollTop: $(document).height() }, 'slow');
                    } else {
                        this.need_payment = 1;
                        toast.error(this.$t('Payment failed'), {
                            autoClose: 5000,
                            position: toast.POSITION.TOP_CENTER,
                            closeButton: false
                        });
                    }
                }).catch(error => {
                    toast.error(this.$t('checkout Id is not correct'), {
                        autoClose: 5000,
                        position: toast.POSITION.TOP_CENTER,
                        closeButton: false
                    });
                });
            } else {
                localStorage.setItem("is_invoice_send", 0);
            }
        }
        that = this;
        $('.pre-loader').show();
        this.searchData = JSON.parse(localStorage.getItem("searchData"));
        this.departure_flight = JSON.parse(localStorage.getItem("departure_flight"));
        this.arrival_flight = JSON.parse(localStorage.getItem("arrival_flight"));
        this.tripType = localStorage.getItem("tripType");
        this.allowed_to_request_hotel_reservation = localStorage.getItem("allowed_to_request_hotel_reservation");
        var guest_data = JSON.parse(localStorage.getItem("guest_data"));
        this.essential_guest = localStorage.getItem("essential_guest");

        if (!this.searchData) {
            window.location = '/erorr';
        }
        this.passengers = JSON.parse(localStorage.getItem("passengersDetails"));
        this.airlines = airlinesData;

        if (this.tripType == 'oneway') {
            var departure_flight_count = this.departure_flight.itineraries[0].segments.length;
            var departure = jsonDataEn.filter(item => {
                return item.code.includes(this.searchData.to);
            });
            var arrival = jsonDataEn.filter(item => {
                return item.code.includes(this.searchData.from);
            });
            var departureLat = departure[0]['lat'],
                departureLng = departure[0]['lng'];
            var arrivalLat = arrival[0]['lat'],
                arrivalLng = arrival[0]['lng'];
            var aa = ``, bb = ``;
            for (let index = 0; index < this.departure_flight.itineraries[0].segments.length; index++) {
                var depa = jsonDataEn.filter(item => {
                    return item.code.includes(this.departure_flight.itineraries[0].segments[index].departure.iataCode);
                });
                var depaLat = depa[0]['lat'],
                    depaLng = depa[0]['lng'];
                aa += ` &markers=icon:https://dsx9kbtamfpyb.cloudfront.net/desktop-web-fav4/view/assets/img/dept-out.png
                  |color:red%7Clabel:K%7C
                  ${depaLat},${depaLng}`;
                bb += `|${depaLat},${depaLng}`;
                var arr = jsonDataEn.filter(item => {
                    return item.code.includes(this.departure_flight.itineraries[0].segments[index].arrival.iataCode);
                });
                var arrLat = arr[0]['lat'],
                    arrLng = arr[0]['lng'];
                aa += ` &markers=icon:https://dsx9kbtamfpyb.cloudfront.net/desktop-web-fav4/view/assets/img/dept-out.png
                  |color:red%7Clabel:K%7C
                  ${arrLat},${arrLng}`;
                bb += `|${arrLat},${arrLng}`;

            }
            this.getOutboundImg = `https://maps.google.com/maps/api/staticmap?
                  center=${((parseFloat(departureLat) + parseFloat(arrivalLat)) / 2)},${((parseFloat(departureLng) + parseFloat(arrivalLng)) / 2)}
                  &type=terrain
                  &size=550x${departure_flight_count == 1 ? 350 : departure_flight_count * 200}
                  &key=AIzaSyCU_-f44KpO2Mhupb-qWLQY-bp0_tQaUzs
                  ${aa}
                  &path=color:0x3366CC
                  |weight:4
                  |geodesic:true
                  ${bb}
                  &sensor=false
                  &region=ar`;
            var jsonData = jsonDataAr;
            if (this.$i18n.locale === 'en') {
                jsonData = jsonDataEn;
            }

            this.departure = jsonData.filter(item => {
                return item.code.includes(this.searchData.from);
            })[0].city;
            this.arrival = jsonData.filter(item => {
                return item.code.includes(this.searchData.to);
            })[0].city;
            var type = 0;
            var array = ``;
            for (let index = 0; index < this.departure_flight.itineraries[type].segments.length; index++) {
                var departure = jsonData.filter(item => {
                    return item.code.includes(this.departure_flight.itineraries[type].segments[index].departure.iataCode);
                });
                var arrival = jsonData.filter(item => {
                    return item.code.includes(this.departure_flight.itineraries[type].segments[index].arrival.iataCode);
                });
                if (this.departure_flight.itineraries[type].segments.length > 1 && index > 0) {
                    const dateTime1 = new Date(this.departure_flight.itineraries[type].segments[index].departure.at);
                    const dateTime2 = new Date(this.departure_flight.itineraries[type].segments[index - 1].arrival.at);
                    const differenceInMs = Math.abs(dateTime2 - dateTime1);
                    const hours = Math.floor(differenceInMs / (1000 * 60 * 60));
                    const minutes = Math.floor((differenceInMs % (1000 * 60 * 60)) / (1000 * 60));
                    if (that.$i18n.locale === 'ar') {
                        array += `<div class="clearfix layover"><span> ${hours}س ${minutes}د ${that.$t('Stop')}</span></div>`;
                    } else {
                        array += `<div class="clearfix layover"><span> stop ${hours}h ${minutes}m</span></div>`;
                    }
                }
                array += `
                    <div class="row no-margin p20 fl-itinerary">
                        <div class="col-md-4 mt20 text-center">
                          <div>
                            <h3 class="prime-color">${this.departure_flight.itineraries[type].segments[index].departure.iataCode}</h3>
                            <h4 class="no-margin new-light">${new
                        Date(this.departure_flight.itineraries[type].segments[index].departure.at).toLocaleTimeString('fr-FR', {
                            hour:
                                '2-digit', minute: '2-digit'
                        })}</h4> <span>${new Date(this.departure_flight.itineraries[type].segments[index].departure.at).toLocaleDateString('en-US',
                            { day: 'numeric' })} ${that.$t(new Date(this.departure_flight.itineraries[type].segments[index].departure.at).toLocaleDateString('en-US', {
                                month:
                                    'long'
                            }))} ${new
                                Date(this.departure_flight.itineraries[type].segments[index].departure.at).getFullYear()}</span>
                          </div>
                          <div>
                            <div class="ellipsis no-wrap">${departure[0].name}</div>
                            <div class="ellipsis no-wrap">${departure[0].city}, ${departure[0].country}</div>
                          </div>
                        </div>
                        <div class="col-md-4 text-center">
                          <div class="mb5">
                            <div class="fl-img-con">
                              <div class="flight-image i-${this.departure_flight.itineraries[type].segments[index].carrierCode.toString().toLowerCase()}"></div>
                            </div>
                            <p class="no-margin font-12"> <span>${this.airlines[this.departure_flight.itineraries[type].segments[index].carrierCode][this.$i18n.locale]}</span> <span class="clearfix">${this.departure_flight.itineraries[type].segments[index].carrierCode}${this.departure_flight.itineraries[type].segments[index].number}</span>
                            </p> <span>${that.$t(this.departure_flight.travelerPricings[0].fareDetailsBySegment[0].cabin)}</span>
                            <div class="clearfix">
                              <div class="oneway"></div>
                            </div>
                          </div>
                          <div>
                            <div></div>
                            <div>${that.convertDuration(this.departure_flight.itineraries[type].segments[index].duration)}</div>
                          </div>
                        </div>
                        <div class="col-md-4 mt20 text-center">
                          <div>
                            <h3 class="prime-color">${this.departure_flight.itineraries[type].segments[index].arrival.iataCode}</h3>
                            <h4 class="no-margin new-light">${new
                        Date(this.departure_flight.itineraries[type].segments[index].arrival.at).toLocaleTimeString('fr-FR', {
                            hour:
                                '2-digit', minute: '2-digit'
                        })}</h4> 
                              <span>${new Date(this.departure_flight.itineraries[type].segments[index].arrival.at).toLocaleDateString('en-US',
                            { day: 'numeric' })} ${that.$t(new Date(this.departure_flight.itineraries[type].segments[index].arrival.at).toLocaleDateString('en-US', {
                                month:
                                    'long'
                            }))} ${new
                                Date(this.departure_flight.itineraries[type].segments[index].arrival.at).getFullYear()}</span>
                          </div>
                          <div>
                            <div class="ellipsis no-wrap">${arrival[0].name}</div>
                            <div class="ellipsis no-wrap">${arrival[0].city}, ${arrival[0].country}</div>
                          </div>
                        </div>
                      </div>
                     `;
                if (index == 0) {
                    this.departure_time_for_riyadh = this.departure_flight.itineraries[type].segments[index].departure.at;
                }
            }
            $('.departure-itinerary .itinerary').html(array);
        } else if (this.tripType == 'roundtrip') {
            var departure_flight_count = this.departure_flight.itineraries[0].segments.length,
                arrival_flight_count = this.departure_flight.itineraries[1].segments.length;
            var departure = jsonDataEn.filter(item => {
                return item.code.includes(this.searchData.from);
            });
            var arrival = jsonDataEn.filter(item => {
                return item.code.includes(this.searchData.to);
            });
            var departureLat = departure[0]['lat'],
                departureLng = departure[0]['lng'];
            var arrivalLat = arrival[0]['lat'],
                arrivalLng = arrival[0]['lng'];

            var aa = ``, bb = ``;
            for (let index = 0; index < this.arrival_flight.itineraries[1].segments.length; index++) {
                var depa = jsonDataEn.filter(item => {
                    return item.code.includes(this.arrival_flight.itineraries[1].segments[index].departure.iataCode);
                });
                var depaLat = depa[0]['lat'],
                    depaLng = depa[0]['lng'];
                aa += ` &markers=icon:https://dsx9kbtamfpyb.cloudfront.net/desktop-web-fav4/view/assets/img/dept-out.png
                  |color:red%7Clabel:K%7C
                  ${depaLat},${depaLng}`;
                bb += `|${depaLat},${depaLng}`;
                var arr = jsonDataEn.filter(item => {
                    return item.code.includes(this.arrival_flight.itineraries[1].segments[index].arrival.iataCode);
                });
                var arrLat = arr[0]['lat'],
                    arrLng = arr[0]['lng'];
                aa += ` &markers=icon:https://dsx9kbtamfpyb.cloudfront.net/desktop-web-fav4/view/assets/img/dept-out.png
                  |color:red%7Clabel:K%7C
                  ${arrLat},${arrLng}`;
                bb += `|${arrLat},${arrLng}`;

            }
            this.getInboundImg = `https://maps.google.com/maps/api/staticmap?
                  center=${((parseFloat(departureLat) + parseFloat(arrivalLat)) / 2)},${((parseFloat(departureLng) + parseFloat(arrivalLng)) / 2)}
                  &type=terrain
                  &size=550x${arrival_flight_count == 1 ? 350 : arrival_flight_count * 200}
                  &key=AIzaSyCU_-f44KpO2Mhupb-qWLQY-bp0_tQaUzs
                  ${aa}
                  &path=color:0x7366CC
                  |weight:4
                  |geodesic:true
                  ${bb}
                  &sensor=false
                  &region=ar`;
            var departure = jsonDataEn.filter(item => {
                return item.code.includes(this.searchData.to);
            });
            var arrival = jsonDataEn.filter(item => {
                return item.code.includes(this.searchData.from);
            });
            var departureLat = departure[0]['lat'],
                departureLng = departure[0]['lng'];
            var arrivalLat = arrival[0]['lat'],
                arrivalLng = arrival[0]['lng'];
            var aa = ``, bb = ``;
            for (let index = 0; index < this.departure_flight.itineraries[0].segments.length; index++) {
                var depa = jsonDataEn.filter(item => {
                    return item.code.includes(this.departure_flight.itineraries[0].segments[index].departure.iataCode);
                });
                var depaLat = depa[0]['lat'],
                    depaLng = depa[0]['lng'];
                aa += ` &markers=icon:https://dsx9kbtamfpyb.cloudfront.net/desktop-web-fav4/view/assets/img/dept-out.png
                  |color:red%7Clabel:K%7C
                  ${depaLat},${depaLng}`;
                bb += `|${depaLat},${depaLng}`;
                var arr = jsonDataEn.filter(item => {
                    return item.code.includes(this.departure_flight.itineraries[0].segments[index].arrival.iataCode);
                });
                var arrLat = arr[0]['lat'],
                    arrLng = arr[0]['lng'];
                aa += ` &markers=icon:https://dsx9kbtamfpyb.cloudfront.net/desktop-web-fav4/view/assets/img/dept-out.png
                  |color:red%7Clabel:K%7C
                  ${arrLat},${arrLng}`;
                bb += `|${arrLat},${arrLng}`;

            }
            this.getOutboundImg = `https://maps.google.com/maps/api/staticmap?
                  center=${((parseFloat(departureLat) + parseFloat(arrivalLat)) / 2)},${((parseFloat(departureLng) + parseFloat(arrivalLng)) / 2)}
                  &type=terrain
                  &size=550x${departure_flight_count == 1 ? 350 : departure_flight_count * 200}
                  &key=AIzaSyCU_-f44KpO2Mhupb-qWLQY-bp0_tQaUzs
                  ${aa}
                  &path=color:0x3366CC
                  |weight:4
                  |geodesic:true
                  ${bb}
                  &sensor=false
                  &region=ar`;
            var jsonData = jsonDataAr;
            if (this.$i18n.locale === 'en') {
                jsonData = jsonDataEn;
            }

            this.departure = jsonData.filter(item => {
                return item.code.includes(this.searchData.from);
            })[0].city;
            this.arrival = jsonData.filter(item => {
                return item.code.includes(this.searchData.to);
            })[0].city;
            var type = 0;
            var array = ``;
            for (let index = 0; index < this.departure_flight.itineraries[type].segments.length; index++) {
                var departure = jsonData.filter(item => {
                    return item.code.includes(this.departure_flight.itineraries[type].segments[index].departure.iataCode);
                });
                var arrival = jsonData.filter(item => {
                    return item.code.includes(this.departure_flight.itineraries[type].segments[index].arrival.iataCode);
                });
                if (this.departure_flight.itineraries[type].segments.length > 1 && index > 0) {
                    const dateTime1 = new Date(this.departure_flight.itineraries[type].segments[index].departure.at);
                    const dateTime2 = new Date(this.departure_flight.itineraries[type].segments[index - 1].arrival.at);
                    const differenceInMs = Math.abs(dateTime2 - dateTime1);
                    const hours = Math.floor(differenceInMs / (1000 * 60 * 60));
                    const minutes = Math.floor((differenceInMs % (1000 * 60 * 60)) / (1000 * 60));
                    if (that.$i18n.locale === 'ar') {
                        array += `<div class="clearfix layover"><span> ${hours}س ${minutes}د ${that.$t('Stop')}</span></div>`;
                    } else {
                        array += `<div class="clearfix layover"><span> stop ${hours}h ${minutes}m</span></div>`;
                    }
                }
                array += `
                    <div class="row no-margin p20 fl-itinerary">
                        <div class="col-md-4 mt20 text-center">
                          <div>
                            <h3 class="prime-color">${this.departure_flight.itineraries[type].segments[index].departure.iataCode}</h3>
                            <h4 class="no-margin new-light">${new
                        Date(this.departure_flight.itineraries[type].segments[index].departure.at).toLocaleTimeString('fr-FR', {
                            hour:
                                '2-digit', minute: '2-digit'
                        })}</h4> <span>${new Date(this.departure_flight.itineraries[type].segments[index].departure.at).toLocaleDateString('en-US',
                            { day: 'numeric' })} ${that.$t(new Date(this.departure_flight.itineraries[type].segments[index].departure.at).toLocaleDateString('en-US', {
                                month:
                                    'long'
                            }))} ${new
                                Date(this.departure_flight.itineraries[type].segments[index].departure.at).getFullYear()}</span>
                          </div>
                          <div>
                            <div class="ellipsis no-wrap">${departure[0].name}</div>
                            <div class="ellipsis no-wrap">${departure[0].city}, ${departure[0].country}</div>
                          </div>
                        </div>
                        <div class="col-md-4 text-center">
                          <div class="mb5">
                            <div class="fl-img-con">
                              <div class="flight-image i-${this.departure_flight.itineraries[type].segments[index].carrierCode.toString().toLowerCase()}"></div>
                            </div>
                            <p class="no-margin font-12"> <span>${this.airlines[this.departure_flight.itineraries[type].segments[index].carrierCode][this.$i18n.locale]}</span> <span class="clearfix">${this.departure_flight.itineraries[type].segments[index].carrierCode}${this.departure_flight.itineraries[type].segments[index].number}</span>
                            </p> <span>${that.$t(this.departure_flight.travelerPricings[0].fareDetailsBySegment[0].cabin)}</span>
                            <div class="clearfix">
                              <div class="oneway"></div>
                            </div>
                          </div>
                          <div>
                            <div></div>
                            <div>${that.convertDuration(this.departure_flight.itineraries[type].segments[index].duration)}</div>
                          </div>
                        </div>
                        <div class="col-md-4 mt20 text-center">
                          <div>
                            <h3 class="prime-color">${this.departure_flight.itineraries[type].segments[index].arrival.iataCode}</h3>
                            <h4 class="no-margin new-light">${new
                        Date(this.departure_flight.itineraries[type].segments[index].arrival.at).toLocaleTimeString('fr-FR', {
                            hour:
                                '2-digit', minute: '2-digit'
                        })}</h4> 
                              <span>${new Date(this.departure_flight.itineraries[type].segments[index].arrival.at).toLocaleDateString('en-US',
                            { day: 'numeric' })} ${that.$t(new Date(this.departure_flight.itineraries[type].segments[index].arrival.at).toLocaleDateString('en-US', {
                                month:
                                    'long'
                            }))} ${new
                                Date(this.departure_flight.itineraries[type].segments[index].arrival.at).getFullYear()}</span>
                          </div>
                          <div>
                            <div class="ellipsis no-wrap">${arrival[0].name}</div>
                            <div class="ellipsis no-wrap">${arrival[0].city}, ${arrival[0].country}</div>
                          </div>
                        </div>
                      </div>
                     `;
                if (index == this.departure_flight.itineraries[type].segments.length - 1) {
                    this.arrival_time_to_riyadh = this.departure_flight.itineraries[type].segments[index].arrival.at;
                }
            }
            $('.departure-itinerary .itinerary').html(array);
            type = 1;
            array = ``;
            for (let index = 0; index < this.arrival_flight.itineraries[type].segments.length; index++) {
                departure = jsonData.filter(item => {
                    return item.code.includes(this.arrival_flight.itineraries[type].segments[index].departure.iataCode);
                });
                arrival = jsonData.filter(item => {
                    return item.code.includes(this.arrival_flight.itineraries[type].segments[index].arrival.iataCode);
                });
                if (this.arrival_flight.itineraries[type].segments.length > 1 && index > 0) {
                    const dateTime1 = new Date(this.arrival_flight.itineraries[type].segments[index].departure.at);
                    const dateTime2 = new Date(this.arrival_flight.itineraries[type].segments[index - 1].arrival.at);
                    const differenceInMs = Math.abs(dateTime2 - dateTime1);
                    const hours = Math.floor(differenceInMs / (1000 * 60 * 60));
                    const minutes = Math.floor((differenceInMs % (1000 * 60 * 60)) / (1000 * 60));
                    if (that.$i18n.locale === 'ar') {
                        array += `<div class="clearfix layover"><span> ${hours}س ${minutes}د ${that.$t('Stop')}</span></div>`;
                    } else {
                        array += `<div class="clearfix layover"><span> stop ${hours}h ${minutes}m</span></div>`;
                    }
                }
                array += `
                     <div class="row no-margin p20 fl-itinerary">
                        <div class="col-md-4 mt20 text-center">
                          <div>
                            <h3 class="prime-color">${this.arrival_flight.itineraries[type].segments[index].departure.iataCode}</h3>
                            <h4 class="no-margin new-light">${new
                        Date(this.arrival_flight.itineraries[type].segments[index].departure.at).toLocaleTimeString('fr-FR', {
                            hour:
                                '2-digit', minute: '2-digit'
                        })}</h4> <span>${new Date(this.arrival_flight.itineraries[type].segments[index].departure.at).toLocaleDateString('en-US',
                            { day: 'numeric' })} ${that.$t(new Date(this.arrival_flight.itineraries[type].segments[index].departure.at).toLocaleDateString('en-US', {
                                month:
                                    'long'
                            }))} ${new
                                Date(this.arrival_flight.itineraries[type].segments[index].departure.at).getFullYear()}</span>
                          </div>
                          <div>
                            <div class="ellipsis no-wrap">${departure[0].name}</div>
                            <div class="ellipsis no-wrap">${departure[0].city}, ${departure[0].country}</div>
                          </div>
                        </div>
                        <div class="col-md-4 text-center">
                          <div class="mb5">
                            <div class="fl-img-con">
                              <div class="flight-image i-${this.arrival_flight.itineraries[type].segments[index].carrierCode.toString().toLowerCase()}"></div>
                            </div>
                            <p class="no-margin font-12"> <span>${this.airlines[this.arrival_flight.itineraries[type].segments[index].carrierCode][this.$i18n.locale]}</span> <span class="clearfix">${this.departure_flight.itineraries[type].segments[index].carrierCode}${this.departure_flight.itineraries[type].segments[index].number}</span>
                            </p> <span>${that.$t(this.arrival_flight.travelerPricings[0].fareDetailsBySegment[0].cabin)}</span>
                            <div class="clearfix">
                              <div class="oneway"></div>
                            </div>
                          </div>
                          <div>
                            <div></div>
                            <div>${that.convertDuration(this.arrival_flight.itineraries[type].segments[index].duration)}</div>
                          </div>
                        </div>
                        <div class="col-md-4 mt20 text-center">
                          <div>
                            <h3 class="prime-color">${this.arrival_flight.itineraries[type].segments[index].arrival.iataCode}</h3>
                            <h4 class="no-margin new-light">${new
                        Date(this.arrival_flight.itineraries[type].segments[index].arrival.at).toLocaleTimeString('fr-FR', {
                            hour:
                                '2-digit', minute: '2-digit'
                        })}</h4> 
            <span>${new Date(this.arrival_flight.itineraries[type].segments[index].arrival.at).toLocaleDateString('en-US',
                            { day: 'numeric' })} ${that.$t(new Date(this.arrival_flight.itineraries[type].segments[index].arrival.at).toLocaleDateString('en-US', {
                                month:
                                    'long'
                            }))} ${new
                                Date(this.arrival_flight.itineraries[type].segments[index].arrival.at).getFullYear()}</span>
                          </div>
                          <div>
                            <div class="ellipsis no-wrap">${arrival[0].name}</div>
                            <div class="ellipsis no-wrap">${arrival[0].city}, ${arrival[0].country}</div>
                          </div>
                        </div>
                      </div>
                     `;
                if (index == 0) {
                    this.departure_time_for_riyadh = this.arrival_flight.itineraries[type].segments[index].departure.at;
                }
            }
            $('.arrival-itinerary .itinerary').html(array);
        } else {
            var departure_flight_count = this.departure_flight.itineraries[0].segments.length,
                arrival_flight_count = this.departure_flight.itineraries[1].segments.length;

            var type = 0;
            var array = ``;
            const params = new URLSearchParams(this.searchData.info);
            this.from = params.getAll('from[]');
            this.to = params.getAll('to[]');
            var departure = jsonDataEn.filter(item => {
                return item.code.includes(this.from[0]);
            });
            var arrival = jsonDataEn.filter(item => {
                return item.code.includes(this.to[0]);
            });
            var departureLat = departure[0]['lat'],
                departureLng = departure[0]['lng'];
            var arrivalLat = arrival[0]['lat'],
                arrivalLng = arrival[0]['lng'];
            this.getOutboundImg = `https://maps.google.com/maps/api/staticmap?
                  center=${((parseFloat(departureLat) + parseFloat(arrivalLat)) / 2)},${((parseFloat(departureLng) + parseFloat(arrivalLng)) / 2)}
                  &type=terrain
                  &size=550x${departure_flight_count == 1 ? 350 : departure_flight_count * 200}
                  &key=AIzaSyCU_-f44KpO2Mhupb-qWLQY-bp0_tQaUzs
                  &markers=icon:https://dsx9kbtamfpyb.cloudfront.net/desktop-web-fav4/view/assets/img/dept-out.png
                  |color:red%7Clabel:K%7C
                  ${departureLat},${departureLng}
                  &markers=icon:https://dsx9kbtamfpyb.cloudfront.net/desktop-web-fav4/view/assets/img/arr-out.png
                  |color:red%7Clabel:K%7C
                  ${arrivalLat},${arrivalLng}
                  &markers=icon:https://dsx9kbtamfpyb.cloudfront.net/desktop-web-fav4/view/assets/img/arr-out.png
                  |color:red%7Clabel:K%7C
                  ${arrivalLat},${arrivalLng}
                  &markers=icon:https://dsx9kbtamfpyb.cloudfront.net/desktop-web-fav4/view/assets/img/arr-out.png
                  |color:red%7Clabel:K%7C
                  16.1947,52.1694
                  &path=color:0x7366CC
                  |weight:4
                  |geodesic:true
                  |${departureLat},${departureLng}
                  |${arrivalLat},${arrivalLng}
                  |16.1947,52.1694
                  &sensor=false
                  &region=ar`;
            var jsonData = jsonDataAr;
            if (this.$i18n.locale === 'en') {
                jsonData = jsonDataEn;
            }
            this.departure_flight.itineraries.forEach((itinerarie, key) => {
                itinerarie.segments.forEach((segment, index) => {
                    if (key == 0) {
                        if (index == itinerarie.segments.length - 1) {
                            this.arrival_time_to_riyadh = segment.arrival.at;
                        }
                    } else {
                        if (index == 0) {
                            this.departure_time_for_riyadh = segment.departure.at;
                        }
                    }
                    var departure = jsonData.filter(item => {
                        return item.code.includes(segment.departure.iataCode);
                    });
                    var arrival = jsonData.filter(item => {
                        return item.code.includes(segment.arrival.iataCode);
                    });
                    if (segment.length > 1 && index > 0) {
                        const dateTime1 = new Date(segment.departure.at);
                        const dateTime2 = new Date(segment.arrival.at);
                        const differenceInMs = Math.abs(dateTime2 - dateTime1);
                        const hours = Math.floor(differenceInMs / (1000 * 60 * 60));
                        const minutes = Math.floor((differenceInMs % (1000 * 60 * 60)) / (1000 * 60));
                        if (that.$i18n.locale === 'ar') {
                            array += `<div class="clearfix layover"><span> ${hours}س ${minutes}د ${that.$t('Stop')}</span></div>`;
                        } else {
                            array += `<div class="clearfix layover"><span> stop ${hours}h ${minutes}m</span></div>`;
                        }
                    }
                    array += `
                          <div class="row no-margin mb15 p20 fl-itinerary">
                            <div class="col-md-4 mt20 text-center">
                              <div>
                                <h3 class="prime-color">${segment.departure.iataCode}</h3>
                                <h4 class="no-margin new-light">
                                    ${new Date(segment.departure.at).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })}
                                </h4>
                                <span>
                                    ${new Date(segment.departure.at).toLocaleDateString('en-US', { day: 'numeric' })} 
                                    ${that.$t(new Date(segment.departure.at).toLocaleDateString('en-US', { month: 'long' }))} 
                                    ${new Date(segment.departure.at).getFullYear()}
                                </span>
                              </div>
                              <div>
                                <div class="ellipsis no-wrap">${departure[0].name}</div>
                                <div class="ellipsis no-wrap">${departure[0].city}, ${departure[0].country}</div>
                              </div>
                            </div>
                            <div class="col-md-4 text-center">
                              <div class="mb5">
                                <div class="fl-img-con">
                                  <div class="flight-image i-${segment.carrierCode.toString().toLowerCase()}"></div>
                                </div>
                                <p class="no-margin font-12"> <span>${this.airlines[segment.carrierCode][this.$i18n.locale]}</span> <span class="clearfix">${segment.carrierCode}${segment.number}</span>
                                </p> <span></span>
                                <div class="clearfix">
                                  <div class="oneway"></div>
                                </div>
                              </div>
                              <div>
                                <div></div>
                                <div>${that.convertDuration(segment.duration)}</div>
                              </div>
                            </div>
                            <div class="col-md-4 mt20 text-center">
                              <div>
                                <h3 class="prime-color">${segment.arrival.iataCode}</h3>
                                <h4 class="no-margin new-light">
                                    ${new Date(segment.arrival.at).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })}
                                </h4> 
                                <span>
                                    ${new Date(segment.arrival.at).toLocaleDateString('en-US', { day: 'numeric' })} 
                                    ${that.$t(new Date(segment.arrival.at).toLocaleDateString('en-US', { month: 'long' }))} 
                                    ${new Date(segment.arrival.at).getFullYear()}
                                </span>
                              </div>
                              <div>
                                <div class="ellipsis no-wrap">${arrival[0].name}</div>
                                <div class="ellipsis no-wrap">${arrival[0].city}, ${arrival[0].country}</div>
                              </div>
                            </div>
                          </div>
                       `;
                });
            });
            $('.departure-itinerary .itinerary').html(array);
        }
        this.hotel_conditions = {
            reservation_start_date: new Date(this.arrival_time_to_riyadh).toLocaleDateString('sv-SE'),
            reservation_end_date: new Date(this.departure_time_for_riyadh).toLocaleDateString('sv-SE'),
            free_reservation_start_date: guest_data.policy.free_entry_date_to_the_hotel,
            free_reservation_end_date: guest_data.policy.free_check_out_date_from_the_hotel,
            free_duration: guest_data.policy.number_of_free_nights,
        };
        var arrival_flight = JSON.parse(localStorage.getItem("arrival_flight")),
            departure_flight = JSON.parse(localStorage.getItem("departure_flight"));
        if (this.tripType == 'roundtrip') {
            var arrival_segments_id = [], departure_segments_id = [];
            var arrival_segments = arrival_flight.itineraries[1].segments;
            arrival_segments.forEach(element => {
                arrival_segments_id.push(element.id)
            });
            var departure_segments = departure_flight.itineraries[0].segments;
            departure_segments.forEach(element => {
                departure_segments_id.push(element.id)
            });
            for (let index = 0; index < this.passengers.length; index++) {
                departure_flight.travelerPricings[index].fareDetailsBySegment = departure_flight.travelerPricings[index].fareDetailsBySegment.filter(item => {
                    return departure_segments_id.includes(item.segmentId);
                });
                var arrival_flights_segment = arrival_flight.travelerPricings[index].fareDetailsBySegment.filter(item => {
                    return arrival_segments_id.includes(item.segmentId);
                })
                arrival_flights_segment.forEach(element => {
                    departure_flight.travelerPricings[index].fareDetailsBySegment.push(element);
                });
            }
            departure_flight.itineraries = [departure_flight.itineraries[0], arrival_flight.itineraries[1]];
        }
        var flight = {
            data: {
                type: "flight-offers-pricing",
                flightOffers: [
                    departure_flight
                ]
            }
        };
        var url = `${this.$appUrl}/api/saudicup/pricing`;
        this.axios({
            method: 'post',
            url: url,
            data: {
                flight: flight,
            }
        }).then((response) => {
            var res = response.data.data;
            this.flightOffers = res.data.flightOffers;
            if (response.data.status == 0) {
                $('.tour_details_right_sidebar_wrapper').remove();
                toast.error(this.$t('A problem occurred during the pricing process'), {
                    autoClose: 5000,
                    position: toast.POSITION.TOP_CENTER,
                    closeButton: false
                });
            } else {
                this.total = this.get_price_with_markup(this.flightOffers[0].price.total);
                if (this.payment_status == 1) {
                    if (is_invoice_send == 0) {
                        localStorage.setItem("is_invoice_send", 1);
                        this.send_payment_invoice(this.flightOffers[0].price.total, this.flightOffers[0].price.base, this.markup);
                    }
                }
            }
            if (this.allowed_to_request_hotel_reservation == 0 || this.hotels.length != 0) {
                $('.pre-loader').hide();
            }
        }).catch(error => {
            $('.pre-loader').hide();
            $('.tour_details_right_sidebar_wrapper').remove();
            toast.error(this.$t('A problem occurred during the pricing process'), {
                autoClose: 5000,
                position: toast.POSITION.TOP_CENTER,
                closeButton: false
            });
        });
        if (this.allowed_to_request_hotel_reservation == 1) {
            var url = `${this.$saudicupAppUrl}/api/guest/hotels`;
            this.axios.get(url, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('user_token')}`
                }
            }).then((response) => {
                var data = response.data.data;
                this.hotels = data;
                this.current_hotel = this.hotels[0];
                this.hotel_id = this.current_hotel.id;
                this.hotel_img = `${this.$saudicupAppUrl}/storage` + this.current_hotel.images[0].image;
                var time_allowed_entry_before_booking = this.current_hotel.time_allowed_entry_before_booking;

                var need_extra = this.need_an_extra_day_at_beginning(new Date(this.arrival_time_to_riyadh), this.get_time_formated(this.current_hotel.entry_time), time_allowed_entry_before_booking);
                var free_duration = this.hotel_conditions.free_duration;
                if (need_extra) {
                    this.entry_hotel_date = this.decrease_day_from_date(this.arrival_time_to_riyadh);
                    free_duration = parseInt(free_duration) + 1;
                } else {
                    this.entry_hotel_date = this.date_format(this.arrival_time_to_riyadh);
                }
                this.exit_hotel_date = this.add_days_to_date(this.entry_hotel_date, free_duration);
                if (this.exit_hotel_date > this.departure_time_for_riyadh) {
                    this.exit_hotel_date = new Date(this.departure_time_for_riyadh).toLocaleDateString('fr-CA', {
                        year: 'numeric',
                        month: '2-digit',
                        day: '2-digit',
                    });
                }
                this.need_extra_end = this.need_an_extra_day_at_end(this.exit_hotel_date, this.departure_time_for_riyadh);
                if (this.tripType == 'oneway') {
                    this.exit_hotel_date = null;
                    this.entry_hotel_date = null;
                    this.need_extra_end = false;
                }
                if (this.need_extra_end) {
                    this.count_extra_end = this.count_extra_day_at_end(this.exit_hotel_date, this.departure_time_for_riyadh);
                    this.end_extra_date = this.add_days_to_date(this.exit_hotel_date, this.count_extra_end);
                }
                if (this.flightOffers.length > 0) {
                    $('.pre-loader').hide();
                }
            });
        }
    }
}
</script>
<style lang="scss" scoped>
.color-label {
    color: #8154a1!important;
    font-weight: 700!important;
    .note{
        color: rgb(192, 160, 52);
    }
}
.form-control{
        padding: 5px 22px;
        font-size: 14px;
        height: 37px;
        border-radius: 0.25rem;
}
label{
    font-size: 14px;
    margin-bottom: 8px;
    color: #8154a1;
    font-weight: 600;
}
.form-group{
    margin-bottom: 1rem;
}
.section_padding {
    padding: 60px 0;
}
.page-loader-parent:has(.page-loader) {
    position: relative;
    min-height: 280px;
}

.mb20 {
    margin-bottom: 20px !important;
}

.pass-con {
    background-color: #0a0f57;
    color: #fff;
    padding: 15px;
    border-radius: 3px;
}

.row.align>.col-middle {
    float: none;
    display: inline-block;
    vertical-align: middle;
    clear: both;
    white-space: initial;
}

.rtl .pass-count {
    margin-right: 20px;
    margin-left: 0 !important;
}

.rtl .pass-count span {
    font-size: 14px;
}

.pass-con .btn,
.pass-con .btn:active,
.pass-con .btn:after,
.pass-con .btn:focus,
.pass-con .btn:hover {
    background-color: transparent;
    border: 1px solid #fff;
    color: #fff;
}

.mb30 {
    margin-bottom: 30px !important;
}

.row.align {
    padding: 0;
}

.sticky-parent {
    transition: 1s;
    bottom: 50px;
    position: sticky !important;
    position: -webkit-sticky !important;
    z-index: 100;
    top: 145px;
}

.pass-ticket-con {
    background: #fff;
    padding: 20px;
    border-radius: 3px;
    transition: .8s;
}


.oneway,
.oneway-2x,
.oneway-left,
.roundtrip,
.roundtrip-2x {
    background-repeat: no-repeat;
    display: inline-block;
    width: 50px;
    height: 26px;
    background-position: center;
    vertical-align: middle;
}

.flip {
    transform: scaleX(-1);
}

.fl-30-ico.calendar-pink-ico {
    background-position: -180px -300px;
}

.fl-30-ico {
    background-image: url('~@/assets/img/icons/30x30.png');
    width: 30px;
    height: 30px;
    display: inline-block;
    vertical-align: middle;
    background-repeat: no-repeat;
}

.fl-30-ico.passengers {
    background-position: 0 -90px;
}

.ticket-hole:after {
    right: -30px;
}

.ticket-hole:after,
.ticket-hole:before {
    content: '';
    width: 20px;
    height: 20px;
    background-color: #e6f0ff;
    position: absolute;
    top: -12px;
    border-radius: 50%;
}

.ticket-hole:before {
    left: -30px;
}

.ticket-hole>hr {
    margin-top: 15px;
    margin-bottom: 15px;
    border-top: 1px dashed #a3a3a3;
}

.dash-line {
    border-top: 1px dashed #a3a3a3;
}

.ticket-hole {
    position: relative;
}

.mb0 {
    margin-bottom: 0px;
}

.passenger-info {
    padding-top: 145px;
}

.pass-icon {
    background-image: url('~@/assets/img/icons/addpass.png');
    width: 30px;
    height: 20px;
    margin: 0 5px;
}

.h4,
h4 {
    font-size: 18px;
}

.pass-icon {
    background-position: center;
    display: inline-block;
    background-repeat: no-repeat;
    vertical-align: middle;
}



.frm-js-lbl label {
    right: 0px;
    left: inherit;
}

.frm-js-lbl {
    margin: 0;
    padding: 0;
    border: 0;
    position: relative;
    height: 36px;
}

.pass-spec-container {
    background: #fff;
    max-height: 87px;
    cursor: pointer;
    position: relative;
    padding: 15px;
    border-radius: 3px;
}

.fl-pass-info .pass-image,
.pass-spec-container .pass-image {
    background-color: #2c6dfb;
    color: #fff;
    font-size: 12px;
    border: 0;
    border-radius: 50%;
    margin: 0 15px;
    display: inline-block;
    vertical-align: middle;
    font-size: 18px;
    text-align: center;
    padding: 1;
    width: 40px;
    height: 40px;
    line-height: 35px;
    padding-top: 3px;
}

.mb20 {
    margin-bottom: 20px !important;
}

.pass-spec-container .pass-details .left {
    display: inline-block;
    vertical-align: middle;
}

.pass-spec-container .pass-details {
    display: inline-block;
    width: calc(100% - 35px);
    cursor: pointer;
    white-space: nowrap;
}

.btn-fa {
    width: 25px;
    display: inline-block;
    text-align: center;
    cursor: pointer;
}

.edit-icon {
    background-image: url('~@/assets/img/icons/edit.png');
}

.delete-icon,
.edit-icon {
    width: 23px;
    height: 23px;
}

.edit-icon {
    background-position: center;
    display: inline-block;
    background-repeat: no-repeat;
    vertical-align: middle;
}

.pass-spec-container .pass-details .right {
    text-align: right;
}

.pass-spec-container .pass-details .right {
    display: inline-block;
    vertical-align: middle;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    overflow: hidden;
    max-width: calc(100% - 70px);
    direction: ltr;
    text-align: left;
}

.icheckbox_square,
.icheckbox_square-blue,
.icheckbox_square-green,
.icheckbox_square-grey,
.icheckbox_square-orange,
.icheckbox_square-pink,
.icheckbox_square-purple,
.icheckbox_square-red,
.icheckbox_square-yellow,
.iradio_square,
.iradio_square-blue,
.iradio_square-green,
.iradio_square-grey,
.iradio_square-orange,
.iradio_square-pink,
.iradio_square-purple,
.iradio_square-red,
.iradio_square-yellow {
    display: inline-block;
    vertical-align: middle;
    margin: 0;
    padding: 0;
    width: 22px;
    height: 22px;
    border: none;
}

.no-margin {
    margin: 0;
}

.checkbox-container {
    display: inline-block;
    position: relative;
    padding-left: 25px;
    cursor: pointer;
}

.checkbox-container input[type="radio"] {
    position: absolute;
    opacity: 0;
    cursor: pointer;
}

.checkmark {
    position: absolute;
    top: -12px;
    left: 0;
    height: 22px;
    width: 22px;
    border-radius: 50%;
    border: 1px solid #ccc;
}

.checkbox-container input[type="radio"]:checked~.checkmark {
    background: url('~@/assets/img/green.png') no-repeat;
    background-position: -49px -1px;
}

.checkmark:after {
    content: "";
    position: absolute;
    display: none;
}

.checkbox-container input[type="radio"]:checked~.checkmark:after {
    display: block;
}

.checkbox-container .checkmark:after {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 22px;
    height: 22px;
    border-radius: 50%;
}

.fl-30-ico.info-ico {
    background-position: -120px -270px;
}

.price-text .total {
    font-size: 24px;
}

.price-text .currency {
    font-size: 18px;
}

.new-bold-light {
    font-weight: 600;
    font-style: normal;
    color: #8154a1;
}

.fl-30-ico {
    background-image: url('~@/assets/img/icons/30x30.png');
    width: 30px;
    height: 30px;
    display: inline-block;
    vertical-align: middle;
    background-repeat: no-repeat;
}

.itinerary-content {
    background-color: #fff;
    border-radius: 10px;
    padding-bottom: 5px;
}

#booked-inbound img,
#booked-outbound img,
#inbound-map img,
#outbound-map img {
    width: 100%;
}

.p10 {
    padding: 10px;
}

.fl-back,
.trip-out,
.trip-in,
.chev-arrow.right,
.chev-arrow.left,
.fl-trip .outbound,
.fl-trip .inbound {
    transform: scaleX(-1);
}

.trip-in,
.trip-in.white {
    background-position: -50px 0;
}

.trip-out,
.trip-out.white {
    background-position: 0 0;
}

.trip-in,
.trip-out {
    background: url('~@/assets/img/svg/trip.svg') no-repeat;
    display: inline-block;
    vertical-align: middle;
    width: 50px;
    height: 32px;
    background-size: cover;
}

.psngr-icon {
    background-image: url('~@/assets/img/icons/passengers.png');
    width: 26px;
    height: 25px;
}

.fl-trip {
    display: inline-block;
    vertical-align: middle;
}

.fl-trip {
    margin-right: inherit;
    margin-left: 15px;
}

.ml15 {
    margin-left: 15px !important;
}

.fl-pass-info .seat-img {
    width: 35px;
}

.fl-pass-info {
    padding: 20px 15px;
}

.mr15 {
    margin-right: 15px !important;
}

.fl-30-ico.fl-coupon {
    background-position: -210px 0;
}

.fl-30-ico {
    background-image: url('~@/assets/img/icons/30x30.png');
    width: 30px;
    height: 30px;
    display: inline-block;
    vertical-align: middle;
    background-repeat: no-repeat;
}

.fl-30-ico.fl-cards {
    background-position: -60px -210px;
}

.border-top-1 {
    border-top: 1px solid #f0eeee;
}


.checkbox-container {
    display: inline-block;
    position: relative;
    padding-left: 25px;
    cursor: pointer;
}

.checkbox-container input[type="radio"] {
    position: absolute;
    opacity: 0;
    cursor: pointer;
}

.checkmark {
    position: absolute;
    top: -10px;
    left: 0;
    height: 22px;
    width: 22px;
    border-radius: 50%;
    border: 1px solid #ccc;
}

.checkbox-container input[type="radio"]:checked~.checkmark {
    background: url('~@/assets/img/green.png') no-repeat;
    background-position: -49px -1px;
}

.checkmark:after {
    content: "";
    position: absolute;
    display: none;
}

.checkbox-container input[type="radio"]:checked~.checkmark:after {
    display: block;
}

.checkbox-container .checkmark:after {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 22px;
    height: 22px;
    border-radius: 50%;
}
</style>
<style scoped>
.search-bar-wrapper {
    background-color: #fff;
    background-color: #0a0f57;
    width: 100%;
    margin-bottom: 20px;
    transition: .3s;
    color: #fff;
    z-index: 998;
    width: 100%;
    position: fixed;
    top: 60px;
    max-height: 147px;
}

.fl-back {
    background-image: url('~@/assets/img/icons/back-left.png');
    height: 24px;
    width: 27px;
}

.rtl .fl-back {
    transform: scaleX(-1);
}

.lh-50 {
    line-height: 50px;
}

.pl0 {
    padding-left: 0 !important;
}

.pr0 {
    padding-right: 0 !important;
}

.btn-search-outline {
    background: 0 0;
    border: 1px solid #e6f0ff;
    color: #e6f0ff;
    outline: 0;
    box-shadow: none;
}

.p10 {
    padding: 10px;
}

.bold {
    font-weight: 500;
    font-style: normal;
}

.padding-10-15 {
    padding: 10px 15px;
}

.bk-nav-ul,
.dh-nav-ul {
    list-style: none;
    height: 100%;
    padding: 0;
    min-height: 55px;
    padding-top: 10px;
}

.check-icon.check-white {
    background-position: -16px;
}

.check-icon {
    background-image: url('~@/assets/img/svg/check-16x12.svg');
    height: 12px;
    width: 16px;
    display: inline-block;
    margin: 0 5px;
}

.pull-left {
    float: right !important;
}

.bk-nav-ul>li,
.dh-nav-ul>li {
    display: inline-block;
    height: 100%;
    white-space: nowrap;
}

.corporate-logo {
    display: inline-block;
    background-position: center;
    background-repeat: no-repeat;
    height: 55px;
    object-fit: contain;
    width: 100px;
    margin-right: -20px;
}

.bk-nav-ul>li>a,
.bk-nav-ul>li>div,
.dh-nav-ul>li>a,
.dh-nav-ul>li>div {
    color: rgba(255, 255, 255, .5);
    padding: 10px;
    position: relative;
    display: inline-block;
    vertical-align: middle;
}

.bk-nav-ul>li>a.active {
    color: #fff;
}

.height-100p {
    height: 100%;
}

.booking-nav {
    background-color: #fff;
    background-color: #0a0f57;
    width: 100%;
    margin-bottom: 20px;
    transition: .3s;
    color: #fff;
    z-index: 998;
    width: 100%;
    position: fixed;
    top: 60px;
    height: 65px;
}

.fl-back {
    background-position: center;
    display: inline-block;
    background-repeat: no-repeat;
    vertical-align: middle;
    cursor: pointer;
}

.fl-30-ico.employee-notes {
    background-position: -60px -210px;
}

.division {
    border-bottom: 1px solid #f1f1f1;
    padding: 0;
}

.pull-spinner {
    display: block;
    height: 25px;
    width: 25px;
    margin: 0 auto;
    position: relative;
    left: -4px;
    animation: rotation .6s infinite linear;
    border-left: 4px solid rgba(202, 202, 202, .15);
    border-right: 4px solid rgba(202, 202, 202, .15);
    border-bottom: 4px solid rgba(202, 202, 202, .15);
    border-top: 4px solid rgba(202, 202, 202, .9);
    border-radius: 100%;
}

.fl-ico.negative {
    background-position: -115px -45px;
}

.purposeOfTravel {
    color: #939393;
    margin-top: 24px;
}

.card-type.mada {
    background-position: -111px 0;
    background-image: url('~@/assets/img/svg/mada.svg');
    background-size: cover;
    width: 42px;
    background-position: center;
}

.card-type {
    display: inline-block;
    vertical-align: middle;
    width: 37px;
    height: 28px;
    background-repeat: no-repeat;
    background-image: url('~@/assets/img/icons/37x25.png');
    margin: 0px 5px;
}

.card-type.visa {
    background-position: -37px 0;
}

.card-type.mastercard {
    background-position: 0 0;
}

.card-type.amex {
    background-position: -74px 0;
}

.footer-card {
    position: relative;
}

.card-type.sadad {
    background-position: -74px -28px;
    width: 60px;
}

.ml5 {
    margin-left: 5px !important;
}

.mr5 {
    margin-right: 5px !important;
}

.card-type.bank {
    background-position: -37px -27px;
}
 #inbound-map,
    .flight-map {
        width: 100%;
        position: relative;
        border-radius: 8px;
        overflow: hidden;
        border: 1px solid #a5a5a5;
    }
@media only screen and (max-width: 600px) {
    .sticky-parent {
        position: relative !important;
        top: 20px !important;
    }

    #inbound-map,
    .flight-map {
        min-height: 100% !important;
    }
    .w-30{
        width: 100% !important;
    }
}
</style>
<style lang="scss">
#booking-modal {
    .modal-dialog {
        width: 380px;
        margin-top: 10%;
    }

    h3 {
        font-size: 24px;
    }

    .modal-content {
        border-radius: 5px;
    }

    .bookloader {
        display: inline-block;
        width: 100%;
        height: 105px;
        background-position: center;
        background-image: url('~@/assets/img/svg/loop.svg');
        background-repeat: no-repeat;
    }

    #booking-modal___BV_modal_footer_,
    #booking-modal___BV_modal_header_ {
        display: none !important;
    }

    #booking-modal___BV_modal_body_ {
        padding: 0;
    }
}

#failed-modal {
    .modal-dialog {
        width: 380px;
        margin-top: 10%;
    }

    h3 {
        font-size: 24px;
    }

    .modal-content {
        border-radius: 5px;
    }

    .bookloader {
        display: inline-block;
        width: 100%;
        height: 105px;
        background-position: center;
        background-image: url('~@/assets/img/svg/loop.svg');
        background-repeat: no-repeat;
    }

    #failed-modal___BV_modal_footer_,
    #failed-modal___BV_modal_header_ {
        display: none !important;
    }

    #failed-modal___BV_modal_body_ {
        padding: 0;
    }
}

#policy-modal {
    .modal-dialog {
        width: 380px;
        margin-top: 10%;
    }

    h3 {
        font-size: 24px;
    }

    .modal-content {
        border-radius: 5px;
    }

    .bookloader {
        display: inline-block;
        width: 100%;
        height: 105px;
        background-position: center;
        background-image: url('~@/assets/img/svg/loop.svg');
        background-repeat: no-repeat;
    }

    #policy-modal___BV_modal_footer_,
    #policy-modal___BV_modal_header_ {
        display: none !important;
    }

    #policy-modal___BV_modal_body_ {
        padding: 0;
    }
}
.fl-itinerary>div:last-child {
    border-left: 1px dashed #f0eeee;
    border-right: 0px;
}

.fl-itinerary>div:first-child {
    border-right: 1px dashed #f0eeee;
    border-left: 0px;
}
.rtl .fl-itinerary>div:last-child {
    border-right: 1px dashed #f0eeee;
    border-left: 0px;
}

.rtl .fl-itinerary>div:first-child {
    border-left: 1px dashed #f0eeee;
    border-right: 0px;
}

.text-center {
    text-align: center !important;
}


.h1,
.h2,
.h3,
.h4,
.h5,
.h6,
h1,
h2,
h3,
h4,
h5,
h6 {
    font-family: inherit;
    font-weight: 600;
    line-height: 1.1;
    color: inherit;
}

.section_padding {
    font-size: 14px;
    letter-spacing: .01em;
}
</style>
<style>
.fl-img-con {
    display: inline-block;
    height: 50px;
    width: 50px;
    line-height: 60px;
    position: relative;
    cursor: pointer;
    overflow: hidden;
    background-color: #fff;
    text-align: -webkit-center;
}

.layover {
    text-align: center;
    padding: 10px 0;
    border-left-color: transparent;
    border-right-color: transparent;
    background-color: rgba(230, 240, 255, .7);
    margin: 0 15px;
    color: #507bbc;
}

.mb15 {
    margin-bottom: 15px !important;
}

.p20 {
    padding: 20px;
}

.itinerary-content {
    background-color: #fff;
    border-radius: 10px;
    padding: 20px 10px;
    box-shadow: -4px -5px 14px rgba(0, 0, 0, 0.08), 5px 8px 16px rgba(0, 0, 0, 0.08);
}

.mb20 {
    margin-bottom: 20px !important;
}

.mt15 {
    margin-top: 15px !important;
}

.mb15 {
    margin-bottom: 15px !important;
}

.fl-ico.negative {
    background-position: -115px -45px;
}

.new-bold-light {
    font-weight: 600;
    font-style: normal;
    color: #8154a1;
    font-size: 18px;
}

.bold {
    font-weight: 600;
    font-style: normal;
}

.mt10 {
    margin-top: 10px !important;
}

.fl-trip {
    display: inline-block;
    vertical-align: middle;
    margin-right: inherit;
    margin-left: 15px;
}

.mb20 {
    margin-bottom: 20px !important;
}

.mt15 {
    margin-top: 15px !important;
}

.no-margin {
    margin: 0;
}
</style>